import { getApiBaseUrl } from '../utils/apiConfig.js';

const API_BASE_URL = getApiBaseUrl();

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    credentials: 'include',
    ...options,
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.detail || '请求失败，请稍后重试');
  }
  return data;
}

export async function getUserOverview() {
  return request('/user/overview');
}

export const userCenterService = {
  getUserOverview,
};
